// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2473":"99336cce","4676":"69a531b0","5773":"cefd32b2","9452":"07ba04ee"}[chunkId] + ".chunk.css";
};